import { useAppStore } from '@/store/appStore'
import type { TeamMemberRole } from '@/types'

export interface Permissions {
  role: TeamMemberRole
  /** Can add/edit/delete players, games, events, lineups, settings */
  canEdit: boolean
  /** Can enter stats in live game */
  canEnterStats: boolean
  /** Can manage team members and settings */
  canManageTeam: boolean
  /** Restricted to schedule + stats + live game only */
  isStatistician: boolean
  /** Read-only access everywhere */
  isViewer: boolean
}

export function usePermissions(): Permissions {
  const role = (useAppStore(s => s.activeTeam?.myRole) ?? 'owner') as TeamMemberRole

  return {
    role,
    canEdit:        role === 'owner' || role === 'editor',
    canEnterStats:  role === 'owner' || role === 'editor' || role === 'statistician',
    canManageTeam:  role === 'owner',
    isStatistician: role === 'statistician',
    isViewer:       role === 'viewer',
  }
}
